<template>
	<div>
		<el-table stripe :data="tableData" style="width: 100%;margin-bottom: 20px; color: #000;" border
			@selection-change="handleSelectionChange" size="mini">
			<el-table-column type="selection" width="55" v-if="multSelect">
			</el-table-column>

			<el-table-column prop="stu_name" label="姓名" width="100"></el-table-column>
			<el-table-column prop="exam_num" label="准考证号" width="120"></el-table-column>
			<el-table-column prop="exam_score" label="总分" width="60"></el-table-column>
			<el-table-column prop="volunteer" label="志愿" width="80">
				<template slot-scope="scope">

					<span v-if="scope.row.volunteer==1">第一志愿</span>
					<span v-if="scope.row.volunteer==2">第二志愿</span>
					<span v-if="scope.row.volunteer==3">第三志愿</span>
					<span v-if="scope.row.volunteer==0">服从志愿</span>
				</template>
			</el-table-column>
			<el-table-column prop="gender" label="性别" width="60">
				<template slot-scope="scope">

					<span v-if="scope.row.gender==1">男</span>
					<span v-if="scope.row.gender==2">女</span>

					<span v-if="scope.row.gender==0">未知</span>
				</template>
			</el-table-column>
			<el-table-column prop="graduate_sch_city" label="地区" width="150"></el-table-column>
			<el-table-column prop="yuanxi_name" label="系部" width="120"></el-table-column>
			<el-table-column prop="major_code" label="专业代码" width="90"></el-table-column>
			<el-table-column prop="major_name" label="专业名称" min-width="140"></el-table-column>

			<el-table-column v-if="!$store.state.exprise" prop="phone" label="联系方式"  min-width="120"></el-table-column>
			<el-table-column prop="status" label="状态" width="80">
				<template slot-scope="scope">
					<span v-if="scope.row.status==1" style="color: green;">待缴费</span>
					<span v-if="scope.row.status==2"  style="color: blue;">已缴费</span>
					<span v-if="scope.row.status==3"  style="color: deepskyblue;">已录取</span>
					<span v-if="scope.row.status==4"  style="color: #096DD9;">已分班</span>
					<span v-if="scope.row.status==-1" style="color: orangered;">不通过</span>
					<span v-if="scope.row.status==-2" style="color: orangered;">已退档</span>
					<span v-if="scope.row.status==0"  style="color: gray;">已协议</span>
				</template>
			</el-table-column>
			<el-table-column v-if="!$store.state.exprise" prop="username" label="协议员" width="100"></el-table-column>
			<el-table-column v-if="!$store.state.exprise" prop="cdate" label="协议时间" width="150"></el-table-column>



			<el-table-column v-if="!$store.state.exprise" fixed="right" label="操作" width="100" >
				<template slot-scope="scope">
					<el-popconfirm width="200" confirmButtonText='确定' cancelButtonText='取消' icon="el-icon-info"
						iconColor="red" @confirm="handleDel(scope.row)" placement="left" title="是否确定删除？">
						<a v-if="$store.state.teacherRole.isadmin" slot="reference" size="small" style="color: red;font-size: 12px;margin-right: 10px;">删除</a>
					</el-popconfirm>
					<!-- 南高职不要再次出现协议书 -->
					
					<el-button   type="text" size="small" @click="showPrintDialog(scope.row)">协议书</el-button>
					<!-- <el-button   type="text" size="small" @click="showYSTable(scope.row)">意向表</el-button> -->
					
				</template>
			</el-table-column>
		</el-table>
		<el-pagination @current-change="handlePageChange" :current-page="page.pageIndex" :page-size="page.pageSize"
			:total="page.total" @size-change="handleSizeChange" :page-sizes="page.pageSizes"
			layout="total, prev, pager, next, sizes, jumper">
		</el-pagination>
		<luPrint v-if="showPrint" :stuid="stuid"></luPrint>
		<!-- <yixiangbiao v-if="showYsDialog" :stuinfo="stuinfo"></yixiangbiao> -->
	</div>
</template>
<script>
	import luPrint from "../components/xyPrint.vue"
	// import yixiangbiao from "./xwzz/yixiangbiao.vue"
	export default {
		name: 'Table',
		components:{
			luPrint,
			
		},
		data() {
			return {
				stuid:0,
				stuinfo:null,
				showPrint:false,
				showYsDialog:false
			}
		},
		props: {
			page: {
				type: Object,
			},
			tableData: {
				type: Array,
				default: []
			},
			from: {
				type: String,
				default: ''
			},
			multSelect: {
				type: Boolean,
				default: true
			},
		},
		methods: {
			handleModify(row) {
				this.$emit('handleModify', row)
			},
			handleDel(row) {
				this.$emit('handleDel', row)
			},
			handleSelectionChange(val) {
				this.$emit('handleSelectionChange', val)
			},
			handlePageChange(e) {
				this.$emit('handlePageChange', e)
			},
			handleSizeChange(e) {
				this.$emit('handleSizeChange', e)
			},
			showPrintDialog(e){
				this.stuid = e.id
				this.showPrint = true
			},
			closePrint(){
				this.showPrint = false
			},
			showYSTable(e){
				this.stuinfo = e
				this.showYsDialog = true
			}
		}
	}
</script>
